// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".period-select___fhMeh.beem-react-select .beem-react-select__single-value {\n  text-transform: uppercase;\n}\n.time-field__separator___f3ksx {\n  padding-top: 0.7em;\n}\n", "",{"version":3,"sources":["webpack://./app/componentsV2/Fields/Fields.styles.less"],"names":[],"mappings":"AACE;EACE,yBAAA;AAAJ;AAIA;EACE,kBAAA;AAFF","sourcesContent":[".period-select {\n  &:global.beem-react-select .beem-react-select__single-value {\n    text-transform: uppercase;\n  }\n}\n\n.time-field__separator {\n  padding-top: 0.7em;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"period-select": "period-select___fhMeh",
	"time-field__separator": "time-field__separator___f3ksx"
};
export default ___CSS_LOADER_EXPORT___;
